export default {
  client_id: "",
  client_secret: ""
}
